
export class DateUtil {
	static validateDateBetween(validateDate: Date, minDate: Date, maxDate: Date): boolean {
		return validateDate >= minDate && validateDate <= maxDate;
	}

	static dateToNumber(date: Date): number {
		return date.getFullYear() * 10000
			+ (date.getMonth() + 1) * 100
			+ date.getDate();
	}

	static isoDateToNumber(date: string): number {
		return Number(date.replace(/-/g, ''));
	}

}